module.exports = __webpack_public_path__ + "logoEdge.png";